import { Lock } from "lucide-react";
import { KIT } from "@/constants/testIds";

/** Complete Meal Plan features stay visible with a tasteful lock, never hidden. */
export const LockedFeatureCard = ({ featureKey, title, description, upgradeHref, upgradeLabel = "Unlock" }) => (
  <div
    data-testid={KIT.lockedFeature(featureKey)}
    className="flex items-start gap-4 rounded-[20px] border border-border bg-secondary/50 p-5 transition-colors hover:bg-secondary"
  >
    <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-white text-brand-tealSoft shadow-card">
      <Lock className="h-4 w-4" />
    </span>
    <div className="min-w-0 flex-1 space-y-1">
      <h3 className="font-display text-[15px] font-semibold text-brand-teal">{title}</h3>
      {description && <p className="text-[13px] leading-relaxed text-muted-foreground">{description}</p>}
    </div>
    {upgradeHref && (
      <a
        href={upgradeHref}
        target="_blank"
        rel="noopener"
        className="ps-tap shrink-0 self-center rounded-full px-4 py-2 text-xs font-bold text-brand-orangeInk hover:bg-white"
      >
        {upgradeLabel}
      </a>
    )}
  </div>
);
